/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_Change_InvalidInputs */

const en_error_email_change_invalid = /** @type {(inputs: Error_Email_Change_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That's already the email you sign in with. Enter a different address.`)
};

/**
* | output |
* | --- |
* | "That's already the email you sign in with. Enter a different address." |
*
* @param {Error_Email_Change_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_email_change_invalid = /** @type {((inputs?: Error_Email_Change_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_Change_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_email_change_invalid(inputs)
});